import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/images/logo.png';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-contact">
            <a href="tel:2065664676" className="contact-link">
              <FaPhone /> (206) 566-4676
            </a>
            <a href="https://wa.me/12065664676" className="contact-link whatsapp">
              <FaWhatsapp /> WhatsApp Now
            </a>
            <a href="mailto:info@notarypublic.com" className="contact-link">
              <FaEnvelope /> info@notarypublic.com
            </a>
          </div>
        </div>
      </div>
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src={logo} alt="Notary Public Logo" className="logo-img" />
            </Link>
            <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <Link to="/" className="nav-link">
                Home
              </Link>
              <Link to="/about" className="nav-link">
                About
              </Link>
              <Link to="/services" className="nav-link">
                Services
              </Link>
              <Link to="/online-notarization" className="nav-link">
                Online Notarization
              </Link>
              <Link to="/contact" className="nav-link">
                Contact
              </Link>
              <a href="tel:2065664676" className="btn btn-primary nav-btn">
                Call Now
              </a>
            </div>
            <div className="mobile-menu-btn" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;